import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "container mx-auto p-2" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h1", { class: "text-3xl font-bold" }, "写真一覧", -1);
const _hoisted_3 = { class: "flex flex-row flex-wrap py-4" };
const _hoisted_4 = { class: "w-full px-2 text-left sm:w-1/3 md:w-1/4" };
const _hoisted_5 = { class: "sticky top-0 w-full rounded-xl bg-white p-4" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", { class: "text-lg" }, "検索", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "text-base" }, "投稿日", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_9 = { class: "nav flex flex-col overflow-hidden" };
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { key: 0 };
const _hoisted_12 = { key: 1 };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "text-lg" }, "タグ", -1);
const _hoisted_15 = ["checked", "onClick"];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("hr", { class: "my-4 h-px border-0 bg-gray-200 dark:bg-gray-700" }, null, -1);
const _hoisted_19 = {
    role: "main",
    class: "w-full px-2 pt-1 sm:w-2/3 md:w-3/4"
};
const _hoisted_20 = { class: "flex flex-wrap" };
const _hoisted_21 = ["src"];
const _hoisted_22 = { class: "leading-6" };
const _hoisted_23 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VueDatePicker = _resolveComponent("VueDatePicker");
    const _component_LinkButton = _resolveComponent("LinkButton");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("aside", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchText) = $event)),
                        placeholder: "検索する氏名を入力してください",
                        class: "block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500"
                    }, null, 512), [
                        [_vModelText, _ctx.searchText]
                    ]),
                    _hoisted_7,
                    _createVNode(_component_VueDatePicker, {
                        modelValue: _ctx.searchCreatedDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchCreatedDate) = $event)),
                        range: "",
                        format: _ctx.dateFormat,
                        locale: "ja"
                    }, null, 8, ["modelValue", "format"]),
                    _hoisted_8,
                    _createElementVNode("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoFilters, (filter, k) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "nav-item",
                                key: k
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["nav-link truncate text-black hover:text-opacity-60",
                                        filter.key === _ctx.statusFilter ||
                                            (filter.key === 'allphotos' && _ctx.statusFilter === '')
                                            ? 'bg-amber-200'
                                            : ''
                                    ]),
                                    onClick: ($event) => (_ctx.updateStatusFilter(filter.key))
                                }, [
                                    _createTextVNode(_toDisplayString(filter.name) + " ", 1),
                                    (filter.key === 'allphotos')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (" + _toDisplayString(_ctx.photoCounter["all"]) + ") ", 1))
                                        : (filter.photoStatus)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(_ctx.photoCounter[filter.photoStatus] || 0) + ") ", 1))
                                            : _createCommentVNode("", true)
                                ], 10, _hoisted_10)
                            ]));
                        }), 128))
                    ]),
                    _hoisted_13,
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTags, (tag, k) => {
                        return (_openBlock(), _createElementBlock("div", { key: k }, [
                            _createElementVNode("div", {
                                class: "m-px inline-block h-3 w-3 rounded-md",
                                style: _normalizeStyle({ 'background-color': tag.color })
                            }, null, 4),
                            _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.tagFilters[tag.id],
                                onClick: ($event) => (_ctx.updateTags(tag.id, $event))
                            }, null, 8, _hoisted_15),
                            _createTextVNode(" " + _toDisplayString(tag.data.name) + " (" + _toDisplayString(_ctx.photoTagCounter[tag.id] || 0) + ") ", 1)
                        ]));
                    }), 128)),
                    _createVNode(_component_LinkButton, {
                        class: "mt-3",
                        path: "tags",
                        name: "タグ管理"
                    }),
                    _hoisted_16,
                    _createVNode(_component_LinkButton, {
                        path: "photos/edit",
                        name: "写真を選んで管理する",
                        query: _ctx.query
                    }, null, 8, ["query"]),
                    _hoisted_17,
                    _createVNode(_component_LinkButton, {
                        path: "users",
                        name: "ユーザー一覧"
                    }),
                    _hoisted_18,
                    _createElementVNode("span", {
                        class: "nav-link truncate text-black hover:text-opacity-60",
                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.logout()))
                    }, " ログアウト ")
                ])
            ]),
            _createElementVNode("main", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPhotos, (photo, k) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: k,
                            class: "w-24"
                        }, [
                            _createVNode(_component_router_link, {
                                to: _ctx.localizedUrl(`/${_ctx.removeSymbols(_ctx.groupId)}/photos/user/${_ctx.removeSymbols(photo.data.uid)}/photo/${_ctx.removeSymbols(photo.id)}`)
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["photoBox relative m-auto w-20", photo.imageListCss.border])
                                    }, [
                                        _createElementVNode("img", {
                                            src: photo.smallPhotoUrl,
                                            class: _normalizeClass(photo.imageListCss.image)
                                        }, null, 10, _hoisted_21),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["absolute left-0 top-0 h-6 w-6 text-sm font-bold", photo.imageListCss.labelClass])
                                        }, [
                                            _createElementVNode("span", _hoisted_22, _toDisplayString(photo.imageListCss.labelMessage), 1)
                                        ], 2)
                                    ], 2),
                                    (_ctx.likesIndexedByPhotoId[photo.id]?.likeCount)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 👍 " + _toDisplayString(_ctx.likesIndexedByPhotoId[photo.id]?.likeCount || 0), 1))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", null, _toDisplayString(_ctx.users[photo.data.uid]?.getRealName() || "Unknown"), 1),
                                    _createElementVNode("div", null, _toDisplayString(photo.formatCreatedAt()), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTagsIndexedByPhotoId(_ctx.$props.tags)[photo.id], (tag, k) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: k,
                                            class: "m-px inline-block h-3 w-3 rounded-md",
                                            style: _normalizeStyle({ 'background-color': tag.color })
                                        }, null, 4));
                                    }), 128))
                                ]),
                                _: 2
                            }, 1032, ["to"])
                        ]));
                    }), 128))
                ])
            ])
        ])
    ]));
}
